import {
  api_get_support_conversations,
  api_get_support_conversation,
  api_reply_support_conversation,
  api_start_support_conversation,
  api_update_support_conversation
} from '../../../queries/supportConversations';

export const supportConversationsStoreActions = self => ({
  set(key, value) {
    self[key] = value;
  },

  async loadInbox(params = {}) {
    self.set('loading', true);
    try {
      const res = await api_get_support_conversations(self.token, params);
      self.set('groups', res?.data?.data ?? []);
    } catch (error) {
      console.error('Failed to load support inbox', error);
    } finally {
      self.set('loading', false);
    }
  },

  async openConversation(conversationId) {
    try {
      const res = await api_get_support_conversation(conversationId, self.token);
      const d = res?.data?.data;
      if (d) {
        self.set('activeConversation', d.conversation);
        self.set('activeMessages', d.messages ?? []);
      }
      return d;
    } catch (error) {
      console.error('Failed to open conversation', error);
    }
  },

  /** Poll refresh for the open thread — no read-marking side effects beyond the API's own. */
  async refreshActive() {
    if (!self.activeConversation) return;
    return self.openConversation(self.activeConversation.id);
  },

  async reply(message) {
    if (!self.activeConversation) throw new Error('No conversation open');
    self.set('sending', true);
    try {
      const res = await api_reply_support_conversation(self.activeConversation.id, message, self.token);
      // the query layer catches and returns error objects instead of throwing
      if (!res || res.error || !res.data?.data) {
        throw new Error(res?.message ?? 'Reply failed');
      }
      await self.openConversation(self.activeConversation.id);
      self.loadInbox();
    } finally {
      self.set('sending', false);
    }
  },

  async startConversation(userId, message, source) {
    self.set('sending', true);
    try {
      const res = await api_start_support_conversation(userId, message, source, self.token);
      const d = res?.data?.data;
      await self.loadInbox();
      if (d?.conversation) await self.openConversation(d.conversation.id);
      return d;
    } finally {
      self.set('sending', false);
    }
  },

  async setStatus(status) {
    if (!self.activeConversation) return;
    await api_update_support_conversation(self.activeConversation.id, status, self.token);
    await self.openConversation(self.activeConversation.id);
    self.loadInbox();
  },

  closeThread() {
    self.set('activeConversation', null);
    self.set('activeMessages', []);
  }
});
